import { render } from "./CuratorRequestsPage.vue?vue&type=template&id=cec6ae4e"
import script from "./CuratorRequestsPage.vue?vue&type=script&lang=js"
export * from "./CuratorRequestsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__